export default {
  "offline": "Offline",
  "healthy": "Healthy",
  "unhealthy": "Unhealthy",
  "error": "Error",
  "connected": "Connected",
  "notConfigured": "Not Configured",
  "na": "N/A",
  "network": "Network",
  "database": "Database",
  "liveThroughput": "Live Throughput",
  "rxDownload": "RX (Download)",
  "txUpload": "TX (Upload)",
  "total": "Total",
  "streamStatus": "Stream Status",
  "interface": "Interface",
  "name": "Name",
  "source": "Source",
  "automatic": "Auto",
  "liveSse": "live SSE",
  "snapshot": "snapshot",
  "vnstatInterface": "vnStat Interface",
  "timezone": "Timezone",
  "trafficTotals": "Traffic Totals",
  "todayRx": "Today RX",
  "todayTx": "Today TX",
  "monthRx": "Month RX",
  "monthTx": "Month TX",
  "last30Days": "Last 30 Days",
  "storage": "Storage",
  "filePath": "File Path",
  "fileSize": "File Size",
  "unavailable": "Unavailable",
  "pageCount": "Page Count",
  "pageSize": "Page Size",
  "configuration": "Configuration",
  "journalMode": "Journal Mode",
  "walMode": "WAL Mode",
  "yes": "Yes",
  "no": "No",
  "health": "Health",
  "integrityCheck": "Integrity Check",
  "ok": "OK",
  "failed": "Failed",
  "server": "Server",
  "uptime": "Uptime",
  "totalSize": "Total Size",
  "connections": "Connections",
  "active": "Active",
  "max": "Max",
  "utilization": "Utilization",
  "topTables": "Top Tables",
  "noTables": "No tables found",
  "checkFailed": "Check failed",
  "runningDots": "Running...",
  "runIntegrity": "Run Integrity Check",
  "actions": "Actions",
  "databaseBrowser": "Database Browser",
  "readOnly": "Read-Only",
  "retry": "Retry",
  "masked": "MASKED",
  "empty": "empty",
  "filterTables": "Filter tables...",
  "noMatchingTables": "No tables match filter",
  "selectTable": "Select a table to browse",
  "loadRowsFailed": "Couldn't load rows",
  "noRows": "No rows",
  "noRowsDetail": "This table has no rows, or you don't have permission to view them.",
  "refresh": "Refresh",
  "previous": "Previous",
  "next": "Next",
  "redisNotConfigured": "Redis is not configured. Configure a Redis connection in Settings to enable telemetry history.",
  "redisUnreachable": "Redis is configured but not reachable. Check the connection settings and ensure the Redis service is running.",
  "version": "Version",
  "mode": "Mode",
  "serviceActive": "Service Active",
  "memory": "Memory",
  "used": "Used",
  "peak": "Peak",
  "fragmentation": "Fragmentation",
  "connectedClients": "Connected Clients",
  "blockedClients": "Blocked Clients",
  "keyspace": "Keyspace",
  "totalKeys": "Total Keys",
  "timeseries": "Timeseries",
  "keys": "Keys",
  "prefixes": "Prefixes",
  "bandwidthHistory": "Bandwidth History (30 days)",
  "networkThroughput": "Network Throughput",
  "dailyTotals": "Daily totals (RX/TX) based on vnStat. Updated automatically.",
  "noBandwidth": "No bandwidth data available yet",
  "vnstatCollecting": "vnStat needs time to collect traffic statistics",
  "samplerWaiting": "Telemetry data will appear once the sampler starts",
  "powerFailed": "Failed to schedule power action",
  "shutdown": "Shutdown",
  "reboot": "Reboot",
  "shutdownScheduled": "Shutdown scheduled",
  "rebootScheduled": "Reboot scheduled",
  "quickActions": "Quick Actions",
  "commonOperations": "Common dashboard operations",
  "refreshing": "Refreshing…",
  "refreshAll": "Refresh all",
  "copied": "Copied!",
  "copyDiagnostics": "Copy diagnostics",
  "viewLogs": "View logs",
  "checkUpdates": "Check updates",
  "rebooting": "Rebooting…",
  "rebootServer": "Reboot server",
  "shuttingDown": "Shutting down…",
  "shutdownServer": "Shut down server",
  "cancelScheduleFailed": "Failed to cancel schedule",
  "scheduleCancelled": "Reboot schedule cancelled",
  "createScheduleFailed": "Failed to create schedule",
  "onceScheduled": "One-time reboot scheduled",
  "recurringScheduled": "Recurring reboot scheduled",
  "poweringOff": "Powering off…",
  "scheduling": "Scheduling…",
  "scheduleReboot": "Schedule Reboot",
  "confirmShutdown": "Confirm Shutdown",
  "rebootExplanation": "Reboot now, or schedule a reboot for later. A reboot briefly drops the dashboard connection while the server restarts.",
  "close": "Close",
  "cancel": "Cancel",
  "rebootNow": "Reboot now",
  "oneTime": "One-time",
  "recurring": "Recurring",
  "pickDateTime": "Pick a date and time",
  "invalidDate": "Invalid date",
  "futureMinute": "Must be at least 1 minute in the future",
  "rebootTiming": "Reboot timing",
  "rebootAt": "Reboot at",
  "every": "Every",
  "unit": "Unit",
  "days": "Days",
  "weeks": "Weeks",
  "atTime": "At time",
  "scheduledReboots": "Scheduled reboots",
  "loadingReboots": "Loading scheduled reboots…",
  "noReboots": "No reboots scheduled.",
  "confirmStopService": "Confirm Stop Service Rule",
  "confirmStopRule": "Confirm Stop Rule",
  "users": "Users",
  "accountSummary": "Dashboard + system accounts",
  "dashboard": "Dashboard",
  "system": "System",
  "recentUsers": "Recent dashboard users",
  "noRecentActivity": "No recent dashboard activity",
  "viewAll": "View all",
  "inventory": "System Inventory",
  "osServices": "OS and core services",
  "os": "OS",
  "kernel": "Kernel",
  "notInstalled": "Not installed",
  "unknown": "Unknown",
  "updated": "Updated",
  "package": "Package",
  "openUpdates": "Open Updates",
  "current": "Current",
  "available": "Available",
  "updatesAvailable": "Updates Available",
  "pendingPackages": "Packages with pending updates",
  "aptOnly": "Applies to APT package rows only.",
  "updateApt": "Update APT Dependencies",
  "checkingUpdates": "Checking for updates…",
  "noUpdates": "No updates available.",
  "searchPackages": "Search packages…",
  "onlyUpdates": "Only packages with updates",
  "viewUpdates": "View updates",
  "updateLists": "Update package lists",
  "upgradePackages": "Update + Upgrade packages",
  "idle": "Idle",
  "confirming": "Confirming",
  "running": "Running",
  "completed": "Completed",
  "aptFailed": "Failed to start APT operation",
  "systemResponse": "System Response",
  "aptManager": "APT Package Manager",
  "closeDialog": "Close dialog",
  "selectOperation": "Select an operation to run:",
  "updateCommand": "Runs apt-get update to refresh package lists.",
  "upgradeCommand": "Runs apt-get update followed by apt-get -y upgrade to install available updates.",
  "upgradeWarning": "Upgrading packages will install new versions. This may require a service restart.",
  "operationCompleted": "Operation completed successfully.",
  "hours24": "24 hours",
  "days7": "7 days",
  "days30": "30 days",
  "year1": "1 year",
  "allTime": "All time",
  "download": "Download",
  "upload": "Upload",
  "ping": "Ping",
  "testHistory": "Test History",
  "historyDescription": "Download/upload throughput and latency over time.",
  "historyRange": "History range",
  "noRangeResults": "No results in this range yet",
  "waitHistory": "Run a test or wait for the schedule to populate history.",
  "historyChart": "Network test history chart of download, upload, and ping over time",
  "loading": "Loading…",
  "loadMore": "Load more",
  "live": "Live",
  "noTests": "No network tests have run yet",
  "runForMetrics": "Run a test to populate latency and throughput metrics.",
  "jitter": "Jitter",
  "onCompletion": "Populates on completion",
  "packetLoss": "Packet Loss",
  "viewReport": "View report",
  "scheduledTests": "Scheduled Tests",
  "scheduledTestsDescription": "Run network tests automatically and retain their history.",
  "enableScheduled": "Enable scheduled tests",
  "intervalHours": "Interval (hours)",
  "retentionDays": "Retention (days)",
  "retentionHint": "0 = keep forever. Older results are pruned beyond this window.",
  "manualOnly": "manual only",
  "scheduledRunning": "Scheduled network test is running.",
  "saved": "Saved",
  "saving": "Saving…",
  "saveSchedule": "Save schedule",
  "networkPerformance": "Network Performance",
  "noTestsHint": "No tests yet — run a speed test to see results.",
  "down": "Down",
  "up": "Up",
  "measuringLatency": "Measuring latency…",
  "testingDownload": "Testing download…",
  "testingUpload": "Testing upload…",
  "preparing": "Preparing…",
  "networkTestFailed": "Failed to start network test",
  "consoleCopied": "Console output copied to clipboard",
  "consoleCopyFailed": "Failed to copy console output",
  "consoleCleared": "Console cleared",
  "runSpeedTest": "Run a Speed Test",
  "speedTestDescription": "Live throughput and latency measured against the best available test server.",
  "testEngine": "Test engine",
  "pingOnly": "Ping only",
  "testing": "Testing…",
  "runTest": "Run Test Now",
  "testComplete": "Test complete",
  "testFailed": "Test failed",
  "lastResultHint": "Showing last result — press Run Test Now to refresh.",
  "idleHint": "Idle — press Run Test Now to begin.",
  "speedGauges": "Speed test gauges",
  "latency": "Latency",
  "console": "Console",
  "lastResult": "(last result)",
  "copyConsoleSafe": "Copy console output — the copy leaves out this server's address",
  "copyConsole": "Copy console output",
  "copy": "Copy",
  "showConsole": "Show console output",
  "hideConsole": "Hide console output",
  "show": "Show",
  "hide": "Hide",
  "clearConsole": "Clear console output",
  "clear": "Clear",
  "consoleHidden": "Console hidden.",
  "showOutput": "Show output",
  "networkOutput": "Network test output",
  "noConsole": "No console output yet. Run a test to see live progress.",
  "copyClipboard": "Copy to clipboard",
  "readableSummary": "Readable summary",
  "downloadTxt": "Download .txt",
  "downloadJson": "Download .json",
  "structuredData": "Structured data",
  "bundle": "Bundle",
  "downloadBundle": "Download bundle",
  "recentAuditIncluded": "Adds recent audit events",
  "categories": "Categories",
  "none": "None",
  "alwaysRecorded": "Always recorded. The server writes this category whatever the audit settings say, because it is the record of what the account controlling those settings did — including deleting audit entries.",
  "exportFailed": "Could not build the diagnostics export",
  "invalidExport": "The server sent something this panel could not read.",
  "clipboardBlocked": "The browser blocked the clipboard. Use the .txt download instead.",
  "fullCopied": "Full detail copied to the clipboard",
  "serverUnreachable": "The request did not reach the server.",
  "diagnostics": "Diagnostics",
  "diagnosticsDescription": "System information for troubleshooting",
  "advanced": "Advanced",
  "refreshDiagnostics": "Refresh diagnostics",
  "refreshToLoad": "Click refresh to load diagnostics.",
  "application": "Application",
  "coreVersion": "Core Version",
  "updateAvailable": "Update available",
  "builtAt": "Built At",
  "environment": "Environment",
  "hostname": "Hostname",
  "architecture": "Architecture",
  "systemUptime": "System Uptime",
  "loadAverage": "Load Average",
  "swap": "Swap",
  "diskRoot": "Disk (/)",
  "services": "Services",
  "clients": "Clients",
  "integrity": "Integrity",
  "audit": "Audit",
  "enabled": "Enabled",
  "exceptLocked": "No — except the locked categories below",
  "retention": "Retention",
  "events24h": "Events (24h)",
  "networkInterfaces": "Network Interfaces",
  "noAddresses": "no addresses",
  "fullDetail": "Full detail",
  "fullExportOptions": "Full detail export options",
  "supportOnly": "Send it to QuickBox support for an open case, and avoid posting it publicly.",
  "clearDate": "Clear date",
  "selectDate": "Select date",
  "selectDateTime": "Select date and time",
  "selectDateRange": "Select date range",
  "time": "Time",
  "hours": "Hours",
  "minutes": "Minutes",
  "amPm": "AM or PM",
  "calendar": "Calendar",
  "previousMonth": "Previous month",
  "nextMonth": "Next month",
  "networkPageDescription": "Measure throughput and latency on demand or on a schedule.",
  "iface": "Interface: {{iface}}",
  "tableSizeRows": "{{size}} / {{count}} rows",
  "rows_one": "{{count}} row",
  "rows_other": "{{count}} rows",
  "columns_one": "{{count}} column",
  "columns_other": "{{count}} columns",
  "maskedCount": "{{count}} masked",
  "rowRange": "{{start}}–{{end}} of {{total}} rows",
  "redisKeys": "{{keys}} keys, {{expires}} expires",
  "realtimeBandwidth": "Real-time RX/TX bandwidth",
  "realtimeBandwidthIface": "Real-time RX/TX bandwidth on {{iface}}",
  "bandwidthChart": "Daily RX and TX totals for the past 30 days",
  "bandwidthChartIface": "Daily RX and TX totals for the past 30 days on {{iface}}",
  "realtimeChart": "Real-time network throughput chart showing RX and TX bandwidth",
  "realtimeChartIface": "Real-time RX/TX throughput chart on {{iface}}",
  "shutdownDemo": "Shutdown scheduled (demo — no action taken)",
  "rebootDemo": "Reboot scheduled (demo — no action taken)",
  "shutdownDemoDetail": "In production the server would power off in ~{{seconds}}s.",
  "rebootDemoDetail": "In production the server would restart in ~{{seconds}}s.",
  "shutdownDetail": "The server will power off in ~{{seconds}}s. Power it back on from your host console — this dashboard will go offline.",
  "rebootDetail": "The server will restart in ~{{seconds}}s. The connection will drop and reconnect once it is back online.",
  "shutdownWarning": "The server will power OFF. It can only be powered back on from your host or provider console — not from this dashboard.",
  "typeConfirm": "Type {{token}} to confirm",
  "everyDays_one": "Every {{count}} day at {{time}}",
  "everyDays_other": "Every {{count}} days at {{time}}",
  "everyWeeks_one": "Every {{count}} week at {{time}}",
  "everyWeeks_other": "Every {{count}} weeks at {{time}}",
  "chooseDays": "Choose 1–{{max}} days and a valid time.",
  "chooseWeeks": "Choose 1–{{max}} weeks and a valid time.",
  "nextAt": "Next: {{time}}",
  "cancelNamed": "Cancel {{name}}",
  "pending_one": "{{count}} pending",
  "pending_other": "{{count}} pending",
  "updatesPending_one": "{{count}} update pending",
  "updatesPending_other": "{{count}} updates pending",
  "checked": "Checked",
  "runUpdate": "Run Update",
  "runUpgrade": "Run Update + Upgrade",
  "operationFailed": "Operation failed.",
  "operationFailedCode": "Operation failed (exit code {{code}}).",
  "intervalHint": "0 = no interval (manual only). Max {{max}}h.",
  "lastRun": "Last run: {{time}}",
  "nextRun": "Next run: {{time}}",
  "never": "Never",
  "now": "now",
  "inDuration": "in {{duration}}",
  "agoDuration": "{{duration}} ago",
  "copiedMasked_one": "Copied without this server's address — {{count}} line changed",
  "copiedMasked_other": "Copied without this server's address — {{count}} lines changed",
  "metricValue": "{{metric}} {{value}}",
  "scale": "scale {{value}}",
  "exportHttpError": "The server responded with {{status}}. Try again, or check that you are still signed in.",
  "freeMemory": "{{free}} free / {{total}}",
  "retentionCount": "{{count}} days",
  "recentErrors": "Recent Errors ({{count}})",
  "networkError": "Network error — could not reach the server",
  "loadSchedulesFailed": "Failed to load reboot schedules",
  "unexpectedResponse": "Unexpected response",
  "fetchFailed": "Fetch failed",
  "loadDiagnosticsFailed": "Failed to load diagnostics",
  "latestResultFailed": "Failed to load latest result",
  "loadScheduleFailed": "Failed to load schedule",
  "saveScheduleFailed": "Failed to save schedule",
  "loadHistoryFailed": "Failed to load history",
  "loadMoreHistoryFailed": "Failed to load more history",
  "requestFailed": "Request failed (HTTP {{status}})",
  "maskedExportHint": "Replaces this server's hostname, its public IPv4 addresses and its IPv6 addresses (a private IPv4 like 10.x, or loopback like ::1, stays), and adapters with custom names. Not enough to make the file anonymous (hardware, versions and timezone still describe it), so avoid posting it publicly.",
  "fullDetailNotice": "The standard exports replace this server's hostname, its public IPv4 addresses and its IPv6 addresses (a private IPv4 like 10.x, or loopback like ::1, stays), and adapters with custom names. These leave them in, so support can match the report to your server.",
  "loadTelemetry": "Unable to load telemetry",
  "loadTelemetryHistory": "Unable to load telemetry history",
  "loadBandwidth": "Unable to load bandwidth",
  "loadInventory": "Unable to load inventory",
  "loadUsers": "Unable to load users",
  "loadUpdates": "Unable to load updates",
  "vnstatMissing": "vnStat is not installed or not available.",
  "vnstatNoData": "vnStat has no data for this interface yet.",
  "vnstatUnreadable": "vnStat returned unreadable data.",
  "vnstatQueryFailed": "Unable to query vnStat right now.",
  "gatewayHint": "{{message}}. Check /health if the gateway is reporting upstream errors.",
  "errorStatus": "{{message}} ({{status}})",
  "connecting": "Connecting",
  "fallback": "Fallback",
  "paused": "Paused",
  "consoleLines_one": "{{count}} line",
  "consoleLines_other": "{{count}} lines",
  "exitCode": "exit {{code}}",
  "job": "Job {{id}}",
  "noWrap": "No Wrap",
  "wrap": "Wrap",
  "scrollBottom": "Scroll to bottom",
  "waitingOutput": "Waiting for output...",
  "streamPolling": "Stream connection lost. Polling for status...",
  "streamRelay": "Dashboard is restarting — streaming continues via relay",
  "streamRestarted": "Dashboard restart complete — finishing post-update work...",
  "consoleSummaryStarting": "Starting network performance test…",
  "consoleSummaryServer": "Server: {{server}}",
  "consoleSummaryIsp": "ISP: {{isp}}",
  "consoleSummaryLatency": "Latency: {{value}}",
  "consoleSummaryJitter": "Jitter: {{value}}",
  "consoleSummaryDownload": "Download: {{value}}",
  "consoleSummaryUpload": "Upload: {{value}}",
  "consoleSummaryLoss": "Packet loss: {{value}}",
  "consoleSummaryCompleted": "Completed {{when}} ({{engine}})"
} as const;
